import "./RequestConversation.module.css";
import Header from "@/reusable_sections/Header";
import ConversationRequestForm from "./sections/ConversationRequestForm";
import Footer from "@/reusable_sections/Footer";
export default function RequestConversationPage() {
  return <div>
      <Header />
      <ConversationRequestForm />
      <Footer />
    </div>;
}